module.exports = __webpack_public_path__ + "static/media/Medylin K.5b99c424.png";